import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import RestoreIcon from "@mui/icons-material/Restore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Chip,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import {
  createSearchParams,
  Link as LinkRRD,
  useNavigate,
} from "react-router-dom";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
// import DrawerUI from '../../components/Drawer'
import { dateConvert } from "../../helper/dateConverter";
import Body from "../../layout/Body";

import { useStyles } from "../../theme/theme";
// import DeleteMission from './DeleteMission'
// import LiveMission from './LiveMission'
// import RestoreMission from './RestoreMission'
// import UnliveMission from './UnliveMission'
// import RedirectMission from './RedirectMission';
import { getAllChallengeAction } from "../../redux/toolkit/challenge/getAllChallenge";
import moment from "moment";
import { getAllLifeLineAction } from "../../redux/toolkit/lifeLine/allLifeLine";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/allLifeLine"
      >
        All LifeLine
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      All Life Line
    </Typography>
  </Stack>
);

const AllLIfeLine = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allLifeLine = useSelector((state) => state.getAllLifeLine);
  const { data, loading, total, status } = allLifeLine;

  const [snack, setSnack] = useState(false);

  const [pageSize, setPageSize] = useState(25);
  const [mission_id, setmission_id] = useState("");
  const classes = useStyles();

  const [date, setDate] = useState({
    start: null,
    end: null,
  });
  

  console.log("data================>", data);

  const qnsDataGridColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1,
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">{params?.row?._id}</Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography color="primary">{params?.row?.name}</Typography>;
      },
    },

    {
      field: "is_active",
      headerName: "Is Active",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{params?.row?.is_active ? "true" : "false"}</Typography>
        );
      },
    },

    {
      field: "description",
      headerName: "description",
      flex: 1,
      minWidth: 270,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.description}</Typography>;
      },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const date = params?.row?.createdAt;
        return (
          <Typography>
            {date ? moment(date).local().format("YYYY-MM-DD hh:mm::ss A") : "-"}
          </Typography>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit Lifeline",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              navigate({
                pathname: `/editLifeline`,
                search: createSearchParams({
                  lifeLineId: params?.row?._id,
                }).toString(),
              });
              
            }}
          >
            <EditIcon color="primary" />
          </IconButton>
        );
      },
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      //   hide: ativeFilter,
    },
  ];

  // use effect
  useEffect(() => {
    dispatch(getAllLifeLineAction());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>Add Life Line</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      {/* <DrawerUI /> */}
      <Body>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Button
            variant="contained"
            color="btn"
            startIcon={<AddIcon />}
            onClick={() => {
              navigate("/createLifeLine");
            }}
          >
            Create LifeLine
          </Button>
        </Stack>

        <Card sx={{ my: 2 }}>
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                           <Box sx={{ p: 2 }}>
                               <Typography color='#071D45'>Filter by Date</Typography>
                               <Stack direction={'row'} spacing={2} sx={{ mt: 1 }} alignItems='center'>
                                   <DatePicker
                                       label="Start Date"
                                       value={date?.start}
                                       onChange={(value) => setDate({ ...date, start: value })}
                                       renderInput={(params) => <TextField {...params} />}
                                       maxDate={date?.end}
   
                                   />
                                   <DatePicker
                                       label="End Date"
                                       value={date?.end}
                                       onChange={(value) => setDate({ ...date, end: value })}
                                       renderInput={(params) => <TextField {...params} />}
                                       minDate={date?.start}
                                   />
                                   <Box>
                                       <IconButton onClick={handleFilterData} color='#071D45'><FilterAltIcon /></IconButton>
                                   </Box>
                               </Stack>
                           </Box>
                       </LocalizationProvider> */}

          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              autoHeight
              rows={data}
              columns={qnsDataGridColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              onCellClick={(params) => {
                setmission_id(params?.row?._id);
              }}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                Toolbar: GridToolbar,
              }}
            />
          </Paper>
        </Card>
      </Body>
    </>
  );
};

export default AllLIfeLine;
